import React from 'react';
import { Link } from 'react-router-dom';
import { logos } from '../../data/images';
interface LogoProps {
  /** Use "white" on dark or photo backgrounds; "color" everywhere else. */
  variant?: 'color' | 'white';
  className?: string;
}
export function Logo({
  variant = 'color',
  className = 'h-10'
}: LogoProps) {
  return <Link to="/" aria-label="ES World home" className="flex shrink-0 items-center" data-id="element-608" data-mp="obxb6s2u6xv5">
      <img src={logos[variant]} alt="ES World" className={`w-auto ${className}`} data-id="element-609" data-mp="kc6ksph82jr5" />
    </Link>;
}